import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useTransferProcess = () => {
  return useMutation({
    mutationFn: (data: any) => api.referral.process(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось отправить данные',
        type: 'error',
      })
    }
  })
}
